import React, { Fragment as F } from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import pluralize from 'pluralize'
import numeral from 'numeral'
import isEmpty from 'lodash/isEmpty'

import Icon from 'discada/dist/Icon'
import { RawExpando } from 'discada/dist/Expando'

import { getVehicleInfo, getYMMT } from 'selectors/inventorySelectors'

import './VehicleInfo.scss'

export function Colors(props) {}
export function Features({ ymmt, vehicleInfo }) {
  let {
    passengers,
    marketClass,
    engine,
    fuelType,
    transmission,
    color,
    cityMpg,
    highwayMpg,
    miles,
    vin,
    stockNumber,
  } = vehicleInfo

  let vehicleDesc = [
      <F key="ymmt">
        Our{' '}
        <strong>
          {ymmt} {stockNumber ? `#${stockNumber}` : ''}
        </strong>
      </F>,
      !isEmpty(marketClass) && (
        <F key="marketClass">
          is a{' '}
          <strong>
            {pluralize(marketClass, 1)} <Icon icon="car-side" />
          </strong>{' '}
        </F>
      ),

      !isEmpty(passengers) && (
        <F key="passengers">
          and room for{' '}
          <strong>
            {passengers} Passengers{' '}
            {[...Array(passengers)].map((p, i) => (
              <Icon key={i} icon={i % 2 === 0 ? 'female' : 'male'} />
            ))}
          </strong>{' '}
        </F>
      ),
    ].filter(x => x),
    mechDesc = [
      !isEmpty(engine) && (
        <F key="engine">
          It's got a{' '}
          <strong>
            {engine} Engine <Icon icon="tachometer-alt" />
          </strong>{' '}
        </F>
      ),

      !isEmpty(fuelType) && (
        <F key="fuel">
          that runs on{' '}
          <strong>
            {fuelType} <Icon icon="gas-pump" />
          </strong>{' '}
        </F>
      ),
      !isEmpty(miles) && (
        <F key="miles">
          and has{' '}
          <strong>
            {numeral(miles).format('0,0')}{' '}
            {pluralize('miles', parseInt(miles, 10))} <Icon icon="road" />
          </strong>{' '}
          on the odometer{' '}
        </F>
      ),
      !isEmpty(transmission) && (
        <F key="transmission">
          and is paired with a{' '}
          <strong>
            {transmission} Transmission <Icon icon="cogs" />
          </strong>{' '}
        </F>
      ),
    ].filter(x => x),
    colorDesc =
      !isEmpty(color) &&
      [
        !isEmpty(color.exterior) && (
          <F key="exterior">
            The outside is painted{' '}
            <strong>
              {color.exterior.description || color.exterior.generic}
            </strong>{' '}
          </F>
        ),
        !isEmpty(color.interior) && (
          <F key="interior">
            The interior is{' '}
            <strong>
              {color.interior.description || color.interior.generic}
            </strong>{' '}
          </F>
        ),
      ].filter(x => x),
    mpgDesc = [
      (cityMpg || highwayMpg) && (
        <F key="mpg">
          You can expect an estimated MPG of{' '}
          <strong>
            {[
              cityMpg && `${cityMpg} city`,
              highwayMpg && `${highwayMpg} highway`,
            ]
              .filter(x => x)
              .join(', ')}{' '}
          </strong>
        </F>
      ),
    ].filter(x => x),
    vinDesc = [
      vin && (
        <F key="mpg">
          This car's Vehicle Identification Number (VIN) is{' '}
          <strong>{vin}</strong>
        </F>
      ),
    ].filter(x => x)

  return (
    <div className="vehicle-info-item">
      <RawExpando>
        {({ toggle, open }) => (
          <span className={c('vehicle-info-item-label', { open })}>
            {vehicleDesc}{' '}
            {!open && (
              <span className="read-more" onClick={toggle}>
                Show More&hellip;
              </span>
            )}
            {open && (
              <span>
                {mechDesc} {colorDesc} {mpgDesc} {vinDesc}
                <br />
                <br />
                And you should make it yours!{' '}
                <span className="read-more" onClick={toggle}>
                  Show Less
                </span>
              </span>
            )}
          </span>
        )}
      </RawExpando>
    </div>
  )
}

export function VehicleInfo(props) {
  let { className } = props

  return (
    <div className={c('vehicle-info', className)}>
      <Features {...props} />
    </div>
  )
}

function mapStateTopProps(state, op) {
  let id = op.vehicleId || op.id

  return {
    ...op,
    ymmt: getYMMT(state, id),
    vehicleInfo: getVehicleInfo(state, id),
  }
}

export default connect(mapStateTopProps)(VehicleInfo)
